<template>
  <b-container fluid style="max-width:1200px;margin-bottom: 5em;">
    <!-- Header -->
    <ulu-device-header
      :device="device"
      :refresh="refresh"
      :loading="loading"
    />
    <hr>
    <!-- Details -->
    <ulu-device-details 
      :device="device"
      :refresh="refresh"
      :loading="loading"
      :contract="device.contract"
      
    />
    <b-row style="margin-top: 1em">
      <b-col>
        <b-tabs active-nav-item-class="text-dark" class="m-1" cards>
          <!-- Refresh Device -->
          <template v-slot:tabs-start>
            <b-nav-item
              @click.prevent="refresh"
              v-b-tooltip.hover
              :title=" $t('globals.reload_device')"
            >
              <v-icon name="sync-alt" :spin="loading" color="gray"></v-icon>
            </b-nav-item>
          </template>
          <!-- Events Table -->
          <b-tab
            :title="$t('globals.events')"
            title-link-class="text-info"
            :diabled="loading"
          >
            <ulu-device-events
              :events="device.events"
              :refresh="refresh"
            />
          </b-tab>
          <!-- History -->
          <b-tab
            :title="$t('globals.history')"
            title-link-class="text-info"
            :diabled="loading"
          >
            <ulu-device-history :audits="device.audits"/>
          </b-tab>
          <!-- Tele2 -->
          <b-tab
            title="Tele2"
            title-link-class="text-info"
            :diabled="loading"
          >
            <ulu-device-tele2 :device="device"/>
          </b-tab>
          <!-- Services -->
          <b-tab
            :title="$t('globals.services')"
            title-link-class="text-info"
            :diabled="loading"
          >
            <ulu-device-services :services="device.services" />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <!-- Notes -->
    <ulu-device-notes 
      :notes="device.notes"
      :refresh="refresh"
      :loading="loading"
    />
    
  </b-container>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  components: {
    "ulu-device-header": () =>
      import("@/components/devices/device/device_header/DeviceHeader"),
    "ulu-device-details": () =>
      import("@/components/devices/device/device_details/DeviceDetails"),
    "ulu-device-events": () =>
      import("@/components/devices/device/DeviceEvents"),
    "ulu-device-history": () =>
      import("@/components/devices/device/DeviceHistory"),
    "ulu-device-notes": () =>
      import("@/components/devices/device/DeviceNotes"),
    "ulu-device-tele2": () =>
      import("@/components/devices/device/DeviceTele2"),
    "ulu-device-services": () =>
      import("@/components/devices/device/DeviceServices")
  },
  data() {
    return {
      loading: false,
      device: {}
    };
  },
  methods: {
    ...mapMutations(["setShowLoadingModal"]),
    ...mapActions("axios_mod", ["simpleFetch"]),
    refresh() {
      if (!this.loading) {
        this.fetchDevice();
      }
    },
    fetchDevice() {
      const data = {
        query: `
          query {
            Device (device_id: ${this.$route.params.id}) {
              imei
              iccid
              created_at
              status
              brand
              product
              batch
              notes
              order {
                id
                order_no
              }
              customer {
                id
                company_name
              }
              events {
                id
                agent {
                  full_name
                }
                brand
                status
                order{
                  id
                  order_no
                }
                customer {
                  id
                  company_name
                }
                sold_at
                created_at
              }
              audits {
                id
                agent {
                  full_name
                }
                action
                created_at
                data
              }
              subscription_price{
                status
                reason
                price_per_month_cents
                order{
                  id
                }
                order_item{
                  id
                  item_name
                  kpi_type
                }
                
              }
              contract{
                contract_type
                start_date
                duration
                termination_policy
              }
              services {
                id
                service_id
                status
                service_device_type
                fieldtracker_reference
                created_at
              }
            }
          }
        `
      };

      this.loading = true;
      this.simpleFetch({ data, this_ref: this })
        .then(res => {
          if (res) {
            this.device = res.Device;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    this.fetchDevice();
  }
};
</script>
